import React from 'react';
import Button from '../../ui/Button';

const MarketerNavbar: React.FC = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const yOffset = -80;
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({top: y, behavior: 'smooth'});
    }
  };

  return (
    <nav className="sticky top-0 z-50 border-b border-slate-800 bg-slate-950/80 backdrop-blur-md">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>
            {/* Hexagon Icon */}
            <div className="relative w-6 h-6 flex items-center justify-center">
               <svg viewBox="0 0 24 24" fill="currentColor" className="text-sky-500 w-full h-full">
                 <path d="M12 2L2 7V17L12 22L22 17V7L12 2Z" />
               </svg>
            </div>
            <span className="text-white font-bold text-lg tracking-tight font-mono">ProGeoData</span>
          </div>
          
          <div className="hidden md:block">
            <div className="ml-10 flex items-baseline space-x-8">
              <button onClick={() => scrollToSection('features')} className="text-slate-400 hover:text-white transition-colors px-3 py-2 text-sm font-medium">
                Solutions
              </button>
              <button onClick={() => scrollToSection('use-cases')} className="text-slate-400 hover:text-white transition-colors px-3 py-2 text-sm font-medium">
                Use Cases
              </button>
              <button onClick={() => scrollToSection('pricing')} className="text-slate-400 hover:text-white transition-colors px-3 py-2 text-sm font-medium">
                Pricing
              </button>
              <button onClick={() => scrollToSection('faq')} className="text-slate-400 hover:text-white transition-colors px-3 py-2 text-sm font-medium">
                FAQ
              </button>
            </div>
          </div>
          
          <div className="flex items-center gap-4">
             <button className="hidden sm:block text-slate-300 hover:text-white text-sm font-medium">
               Login
             </button>
            <Button variant="primary" size="sm" onClick={() => scrollToSection('pricing')}>
              Start Free Trial
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default MarketerNavbar;